import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { CommunicationIntegrationsGridRowType } from "../../../utils/types/common";
import { UserActivityCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/UserActivityCell";

export const IntegrationsCreatedByCellRenderer: FC<
  ICellRendererParams<CommunicationIntegrationsGridRowType>
> = ({ data }) => {
  if (!data) {
    return null;
  }

  const date = data.created_at;
  const details = data.created_by;

  if (!date || !details) {
    return "-";
  }

  return (
    <UserActivityCell
      date={date}
      name={details?.name ?? details?.email ?? ""}
      deleted={details?.status === "deleted"}
      profile={details?.profile}
    />
  );
};
